import { useQuery } from "@tanstack/react-query";
import { me } from "../api";
import { IMe } from "../types";

export default function useMe(enabled: boolean = true) {
    const {isLoading, isFetching, data, isError} = useQuery<IMe>({
        queryKey: ["me"],
        queryFn: me,
        retry: false,
        enabled,
    });

    return {
        meLoading: isLoading,
        meFetching: isFetching,
        meData: data,
        meError: isError,
    };
}